export default {
  meta: {
    public: false,
    auth: true,
    icon: "fa-file-text-o",
    expanded: false,
    label: "Order",
    permission: [config.permission.ORDERS_INDEX, config.permission.SUBSCRIPTIONS_INDEX, config.permission.MEMBERSHIPS_INDEX],
  },
  children: [
    {
      name: "Order",
      path: "/order",
      meta: {
        label: "Orders",
        auth: true,
        breadcrumb: [{ name: "Alacarte" }],
        permission: [config.permission.ORDERS_INDEX]
      },
      component: () => import("views/order/index")
    },
    // {
    //   name: "Subscriptions",
    //   path: "/subscription",
    //   meta: {
    //     label: "Subscriptions",
    //     auth: true,
    //     breadcrumb: [{ name: "Subscriptions" }],
    //     permission: [
    //       config.permission.SUBSCRIPTIONS_INDEX
    //     ]
    //   },
    //   component: () => import("views/subscription/index")
    // },
    {
      name: "membership_orders",
      path: "/membership-orders",
      meta: {
        label: "Memberships",
        auth: true,
        breadcrumb: [{ name: "Membership Orders" }],
        permission: [
          config.permission.MEMBERSHIPS_INDEX
        ]
      },
      component: () => import("views/membership_order/index")
    }
  ]
};